import { render, staticRenderFns } from "./TicketsAgenda.vue?vue&type=template&id=36bfe974&scoped=true&"
import script from "./TicketsAgenda.vue?vue&type=script&lang=js&"
export * from "./TicketsAgenda.vue?vue&type=script&lang=js&"
import style0 from "./TicketsAgenda.vue?vue&type=style&index=0&id=36bfe974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bfe974",
  null
  
)

export default component.exports